// 空の時はundefinedになる場合に利用.空でセットするなら使わずに値をそのまま使うこと.
export class StringTranslator {
  from(bean: string): string {
    return bean
      ? bean
      : "";
  }
  to(object: string): string {
    return object
      ? object
      : undefined;
  }
}
